module.exports = __webpack_public_path__ + "static/luex-92a610ab6c13918f1f26440cee2f06a9.png";